module.exports = __webpack_public_path__ + "img/121_thumbnail.cc922209.jpg";